import {
  DOCUMENT_TYPE_KEY,
  LOCAL_STORAGE_KEYS,
  PROGRAM_MANUAL_STATUS,
} from '../../constants/AppConstants';
import { getLocale, PBStorage } from '../../services/storageService/GlobalData';
import languageService from '../../services/languageService';
import ProgramManualHelper from '../../helpers/ProgramManualHelper';

class ProgramManualManager {
  async saveProgramManual(ProgramManualToSave) {
    try {
      let programManualsArr =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];

      let programManualsToSave = ProgramManualHelper.saveProgramManualsDbModel(
        ProgramManualToSave,
        programManualsArr,
      );

      await PBStorage.set(
        LOCAL_STORAGE_KEYS.PROGRAM_MANUALS,
        programManualsToSave,
      );
      return true;
    } catch (e) {
      console.log('ProgramManual Save fail', e);
      return false;
    }
  }

  async saveDeprecatedProgramManual(deprecaredProgramManuals) {
    let programManuals =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];
    let programManualToSave = [
      ...new Set([...deprecaredProgramManuals, ...programManuals]),
    ];

    let programManualsToSave = ProgramManualHelper.saveProgramManualsDbModel(
      programManualToSave,
      programManuals,
    );

    await PBStorage.set(
      LOCAL_STORAGE_KEYS.PROGRAM_MANUALS,
      programManualsToSave,
    );
  }

  async updateProgramManualStatus(documentNumber, status) {
    try {
      let programManuals =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];

      let programManualIndex = programManuals.findIndex(
        (q) => q.document_number == documentNumber,
      );
      if (programManualIndex != -1) {
        programManuals[programManualIndex].status = status;
        let programManualsToSave =
          ProgramManualHelper.saveProgramManualsDbModel(
            programManuals,
            programManuals,
          );

        await PBStorage.set(
          LOCAL_STORAGE_KEYS.PROGRAM_MANUALS,
          programManualsToSave,
        );
      }
      return true;
    } catch (e) {
      console.log('saveProgramManualfailed', e);
      return false;
    }
  }

  // moveProgramManualtoBin(documentNumber) {
  //   try {
  //     let programManual = ProgBeefDB.objectForPrimaryKey(
  //       DOCUMENT_SCHEMA_NAME,
  //       documentNumber
  //     );

  //     ProgBeefDB.write(() => {
  //       programManual.status = 5;
  //     });
  //     return true;
  //   } catch (e) {
  //     console.log('saveProgramManualfailed', e);
  //     return false;
  //   }
  // }

  // moveProgramManualtoActive(documentNumber) {
  //   try {
  //     let programManuals = await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS) || [];

  //     let programManualIndex = programManuals.findIndex(
  //       (q) => q.document_number == documentNumber
  //     );
  //     programManuals[programManualIndex].status = 2;
  //     this.saveProgramManual(programManuals);
  //     return true;
  //   } catch (e) {
  //     console.log('saveProgramManualfailed', e);
  //     return false;
  //   }
  // }

  // markViewed(feedlotDocumentId) {
  //   try {
  //     let programManual = ProgBeefDB.objectForPrimaryKey(
  //       DOCUMENT_SCHEMA_NAME,
  //       feedlotDocumentId,
  //     );

  //     ProgBeefDB.write(() => {
  //       programManual.document_viewed = 1;
  //     });
  //     return true;
  //   } catch (e) {
  //     console.log('saveProgramManualfailed', e);
  //     return false;
  //   }
  // }

  // deleteURL(urlID) {
  //   try {
  //     console.log('delteURLFailedaa', urlID);
  //     ProgBeefDB.write(() => {
  //       ProgBeefDB.delete(
  //         ProgBeefDB.objectForPrimaryKey(
  //           DOCUMENT_URLS_SCHEMA_NAME,
  //           Number(urlID.feedlot_document_url_id),
  //         ),
  //       );
  //     });
  //     return true;
  //   } catch (e) {
  //     console.log('delteURLFailedaa', e);
  //     return false;
  //   }
  // }

  async getProgramManual(query = '') {
    try {
      let programManuals =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];

      programManuals = programManuals
        .filter((q) => q.status == 2)
        .filter(
          (q) =>
            q.document_number.toLowerCase().includes(query.toLowerCase()) ||
            (q.document_locale[languageService()] &&
              q.document_locale[languageService()].title
                .toLowerCase()
                .includes(query.toLowerCase())),
        );

      programManuals = programManuals.sort((a, b) =>
        a.document_number
          .replace('m-', '')
          .toLowerCase()
          .localeCompare(
            b.document_number.replace('m-', '').toLowerCase(),
            getLocale(),
            { numeric: true },
          ),
      );

      return programManuals;
    } catch (e) {
      console.log('getProgramManual failed', e);
    }
  }

  // getDeprecatedProgramManual() {
  //   let programManual = ProgBeefDB.objects(DOCUMENT_SCHEMA_NAME).filtered(
  //     'status = 5',
  //   );

  //   programManual = programManual.sorted('document_number', false);
  //   return Array.from(programManual);
  // }

  async saveProgramManualTags(tagsToSave) {
    try {
      await PBStorage.set(LOCAL_STORAGE_KEYS.PROGRAM_MANUAL_TAGS, tagsToSave);
      return true;
    } catch (e) {
      console.log('saveProgramManual tags failed', e);
      return false;
    }
  }

  async getProgramManualTags() {
    try {
      let programManualtags =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUAL_TAGS)) || [];

      return programManualtags;
    } catch (e) {
      console.log('getProgramManual tags failed', e);
      return false;
    }
  }

  async getProgramManualById(document_number) {
    try {
      let programManuals =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];
      let programManual = programManuals.find(
        (q) => q.document_number == document_number,
      );

      return programManual;
    } catch (e) {
      console.log('getProgramManualById failed', e);
      return false;
    }
  }

  async getProgramManualActivitiesById(documentNumber) {
    try {
      let activities =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.ACTIVITIES)) || [];
      let assosiatedActivities = [];

      for (let i = 0; i < activities.length; i++) {
        let activity = activities[i];
        for (let j = 0; j < activity.documents.length; j++) {
          let doc = activity.documents[j];
          if (doc.document_number == documentNumber) {
            assosiatedActivities.push(activity);
          }
        }
      }
      assosiatedActivities = assosiatedActivities.sort(function (a, b) {
        return a.activity_number > b.activity_number;
      });

      return assosiatedActivities;
    } catch (e) {
      console.log('getProgramManualActivitiesById failed', e);
      return false;
    }
  }

  async getDeprecatedProgramManuals() {
    try {
      let manuals =
        (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];
      manuals = manuals.filter(
        (q) =>
          q.status == PROGRAM_MANUAL_STATUS.BIN &&
          q.document_type_key == DOCUMENT_TYPE_KEY.TRAINING,
      );
      manuals = manuals.sort(function (a, b) {
        return a.document_number > b.document_number;
      });

      return manuals;
    } catch (e) {
      console.log('getDeprecatedProgramManuals failed', e);
      return false;
    }
  }

  // getMissedProgramManuals() {
  //   let manuals = ProgBeefDB.objects(DOCUMENT_SCHEMA_NAME).filtered(
  //     'status = 6',
  //   );

  //   manuals = manuals.sorted('document_number', false);
  //   return Array.from(manuals);
  // }

  async getTrainings() {
    let trainings =
      (await PBStorage.get(LOCAL_STORAGE_KEYS.PROGRAM_MANUALS)) || [];
    trainings = trainings.filter(
      (training) => training.document_type_key == DOCUMENT_TYPE_KEY.TRAINING,
    );

    return trainings;
  }
}

export default new ProgramManualManager();
